import { authRoleAccess } from 'auth/AuthRoleAccess'
import { lazy } from 'react'


const SupportType = lazy(() => import ('./SupportType.jsx'))

const SupportTypeRoutes = [
    {
        path: '/SupportType',
        component: SupportType,
        auth: authRoleAccess.support_type_creation,
    },
   
]

export default SupportTypeRoutes 